var fonts = [{
  source: "google",
  fonts: [{
    title: "Barlow",
    config: {
      weights: ["400", "400i", "700", "700i"]
    }
  }]
}];
var fontStacks = {
  heading: "'Barlow', serif",
  body: "'Barlow', sans-serif"
};
export { fonts, fontStacks };